export const adminEmailNotifications = [
  "New user signup",
  "New projects",
  "New comments",
];
